import api from "../../../services/api";
import axios from "axios";
export default {
  name: "AdesaoCad",
  props: ["emp"],

  data() {
    return {
      adesao: [],
      titulo: "Nova Adesão",

      logo: "salus.png",
      showTrackingModal: false,   // controla exibição do modal de tracking
      cpfTracking: "",            // CPF digitado no modal
      consultandoCpf: false,      // loading da consulta
      erroCpf: "",                // mensagem de erro do CPF

      ativProf: [],

      form: {
        nome: "",
        cpf: "",
        email: "",
        confEmail: "",
        celular: "",
        celAdic: "",
        fixo: "",
        cep: "",
        cidade: "",
        uf: "",
        bairro: "",
        endereco: "",
        atividadeProf: null,
        regProf: "",
        regNum: "",
        regDataVencimento: null
      },
      cpfBloqueado: false,
      show: true,
      botaoVisivel: true,

      dadosEmpresa: null,
      bgColor: "#a1a1a1",

      naoRecebiCodigo: false,
      codVerificacao: ["", "", "", "", "", ""],

      idSolicitacao: '',

      msgValidacao: '',

      enviandoEmail: false,
      confirmandoEmail: false,

      keyValidacao: null,

      tituloModalVerificacao: 'Validação de e-mail',

      // CT-LGPD: Controle do checkbox de aceite
      aceiteLgpd: false,

      // Controla exibição dos campos de registro profissional
      mostrarCamposRegistro: false

    };
  },

  created() {

    // alert(this.$route.query.emp)
    const empresa = this.$route.query.emp
    const keyValidacao = this.$route.query.keyValidacao
    const cod = this.$route.query.cod
   

    api
      .get(`adesao/empresa/${empresa}/null`)
      .then((res) => {
        // console.log(res.data);
        this.dadosEmpresa = res.data;
        this.bgColor = res.data.cor;
        this.logo = res.data.logoPath;
        this.ativProf = res.data.funcoes.sort((a, b) =>
          (a.text || '').localeCompare(b.text || '', 'pt-BR')
        );

        if (!this.dadosEmpresa) this.$router.push("/adesao/erro");

        if (keyValidacao) {
          
          this.keyValidacao = keyValidacao
          this.tituloModalVerificacao = 'Bem vindo de volta!'

          if (cod && cod.length === 6) {
            // Preenche os 6 dígitos do código
            this.codVerificacao = cod.split('')
          }

          
          this.getDadosSolicitacaoParaConfirmarEmail(keyValidacao)
        
        }

      })
      .catch(() => {
        if (!this.dadosEmpresa) this.$router.push("/adesao/erro");
        //this.msg("ERRO AO BUSCAR", err.response.data, "danger")
      });

  },

   async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const cpfParam = urlParams.get("cpf");

    if (cpfParam) {
       this.form.cpf = cpfParam;
       this.cpfBloqueado = true;

      //remove o param cpf da URL sem recarregar a página
      urlParams.delete("cpf");
      const newUrl = window.location.pathname + 
                    (urlParams.toString() ? "?" + urlParams.toString() : "");
      window.history.replaceState({}, document.title, newUrl);
    }
    // sempre abre o modal de tracking ao carregar a tela
    this.showTrackingModal = true;
 },

  methods: {

    msg(titulo, texto, cor) {
      this.toastCount++;
      this.$bvToast.toast(texto, {
        title: titulo,
        variant: cor,
        solid: true,
        autoHideDelay: 10000,
        appendToast: true
      });
    },
 

    insertAdesao(evt) {
      evt.preventDefault();

      this.botaoVisivel = false

      this.form.idEmpresa = this.dadosEmpresa.id
      this.form.nomeEmpresa = this.dadosEmpresa.nomeEmpresa
      this.form.diasReprovado = this.dadosEmpresa.diasReprovado
      this.form.codUrl = this.dadosEmpresa.codUrl
      
      api
        .post("adesao", { ...this.form, indVerificacaoEmail: this.dadosEmpresa.indVerificacaoEmail })
        .then((res) => {

          //console.log(res.data);
          if (res.data == 'ok') {

            this.msg("ADESÃO", "CADASTRADO COM SUCESSO.", "success");
            localStorage.setItem('idMsg', 10)

          } else 
          if (res.data == 'ok - entrevista') {

            this.msg("ADESÃO", "CADASTRADO COM SUCESSO.", "success");
            localStorage.setItem('idMsg', 15)

          } else 
          if (res.data == 'ok?' || res.data == 'ok? - entrevista') {

            this.$refs['my-modal'].show()
            return

          } else
          if (res.data.precisaVerificar) {

            this.idSolicitacao = res.data.idSolicitacao
            this.msgValidacao = res.data.msgValidacao
            this.$refs['modal-verificacao-email'].show()
            return

          } else if (res.data.includes("http://") || res.data.includes("https://")) {

            this.msg("ADESÃO", "CADASTRADO COM SUCESSO.", "success");
            this.form = '';
            localStorage.setItem('dadosEmpresa', JSON.stringify(this.dadosEmpresa))
            window.location.replace(res.data)
            return

          }

          this.form = '';
          localStorage.setItem('dadosEmpresa', JSON.stringify(this.dadosEmpresa))
          this.$router.push('/msg');

        })
        .catch((err) => {
          this.msg("ATENÇÃO!", err.response.data, "danger")
          this.botaoVisivel = true
        });

    },


    buscarCep() {
      // console.log("cep", this.form.cep);

      this.form.endereco = null
      this.form.bairro = null
      this.form.cidade = null
      this.form.uf = null

      if (this.form.cep.length == 9) {
        // Remove hífen para a BrasilAPI (aceita apenas números)
        const cepNumeros = this.form.cep.replace('-', '')
        const cepFormatado = this.form.cep

        axios
          .get(`https://brasilapi.com.br/api/cep/v1/${cepNumeros}`, { timeout: 3000 })
          .then((res) => {
            console.log(res.data);

            const dadosCep = res.data;
            this.form.endereco = dadosCep.street;
            this.form.bairro = dadosCep.neighborhood;
            this.form.cidade = dadosCep.city;
            this.form.uf = dadosCep.state;
          })
          .catch((err) => {
            if (err.code === 'ECONNABORTED') {
              this.msg("Tempo esgotado", `Não foi possível consultar o CEP ${cepFormatado}. Tente novamente.`, "warning");
            } else {
              this.msg("CEP não encontrado", `O CEP ${cepFormatado} não foi encontrado. Verifique e tente novamente.`, "danger");
            }
          });
      }

    },

    getEntidade() {

      api
      .get('adesao/empresa-entidade/' + this.form.atividadeProf)
      .then((res) => {

        this.form.regProf = res.data

        // Define se os campos de registro devem aparecer
        this.mostrarCamposRegistro = (res.data && res.data !== 'SEM REGISTRO')

        // Limpa os campos se não precisa de registro
        if (!this.mostrarCamposRegistro) {
          this.form.regNum = ''
          this.form.regDataVencimento = null
        }
      })
      .catch(() => this.msg("ATENÇÃO", 'Erro ao buscar entidade', 'danger'));

    },


    hideModal() {
      this.$refs['my-modal'].hide()
    },
    confirmaAdesao(acao) {
      
      this.$refs['my-modal'].hide()

      if (acao == 'sim') {

        api.put(`adesao/confirma-ok/${this.dadosEmpresa.id}/${this.form.cpf}`)
        .then(() => {
          this.form = '';
          localStorage.setItem('idMsg', 10)
          localStorage.setItem('dadosEmpresa', JSON.stringify(this.dadosEmpresa))
          this.$router.push('/msg');
        })
        .catch(() => this.msg("ATENÇÃO", 'Erro...', 'danger'));

      } else {
        
        api.delete(`adesao/${this.dadosEmpresa.id}/${this.form.cpf}`)
        .then(() => {
          this.msg('ADESÃO', 'CADASTRADO NÃO CONCLUÍDO.', 'warning');
        })
        .catch(() => this.msg("ATENÇÃO", 'Erro...', 'danger'));

      }

    },

    handleInput(index) {

      // Garante que apenas números sejam aceitos.
      this.codVerificacao[index] = this.codVerificacao[index].replace(/\D/g, "")

      if (this.codVerificacao[index] && index < this.codVerificacao.length - 1) 
      this.$refs.otpInputs[index + 1].$el.focus()

      if (this.codVerificacao.every((digit) => digit !== "")) 
      this.$emit("otp-completo", this.codVerificacao.join(""))
    
    },

    handleBackspace(index) {

      if (!this.codVerificacao[index] && index > 0) 
      this.$refs.otpInputs[index - 1].$el.focus()

    },

    handleKeydown(event) {
      
      if (event.ctrlKey && event.key === "v") return
      if (event.metaKey && event.key === "v") return
    
      // Impede entrada de caracteres não numéricos (exceto backspace e tab).
      if (!/[0-9]/.test(event.key) && !["Backspace", "Tab"].includes(event.key)) event.preventDefault()

    },

    handlePaste(event, index) {
      
      event.preventDefault()
    
      let pasteData = (event.clipboardData || window.clipboardData).getData("text")
      pasteData = pasteData.replace(/\D/g, "")
    
      if (!pasteData) return
    
      // Distribui os números colados nos campos de entrada.
      for (let i = 0; i < pasteData.length; i++) {

        if (index + i < this.codVerificacao.length) 
        this.$set(this.codVerificacao, index + i, pasteData[i])
      
      }
    
      let nextIndex = index + pasteData.length

      if (nextIndex < this.codVerificacao.length) this.$refs.otpInputs[nextIndex].$el.focus();
    
      // Se todos os campos estiverem preenchidos, emite o evento.
      if (this.codVerificacao.every((digit) => digit !== "")) this.$emit("otp-completo", this.codVerificacao.join(""))

    },    

    confirmarCodigoVerificacao() {

      this.confirmandoEmail = true

      api.post('adesao/confirma-codigo-email', { 
        
        idSolicitacao: this.idSolicitacao, 
        codVerificacao: this.codVerificacao.join(''),
        codUrl: this.dadosEmpresa.codUrl,
        nomeEmpresa: this.dadosEmpresa.nomeEmpresa,
        msgValidacao: this.msgValidacao,

      })
      .then((res) => {

        this.confirmandoEmail = false

        if (res.data == 'ok') {

          this.msg("ADESÃO", "CADASTRADO COM SUCESSO.", "success");
          localStorage.setItem('idMsg', 10)

        } else 
        if (res.data == 'ok - entrevista') {

          this.msg("ADESÃO", "CADASTRADO COM SUCESSO.", "success");
          localStorage.setItem('idMsg', 15)

        } else 
        if (res.data == 'ok?' || res.data == 'ok? - entrevista') {

          this.$refs['my-modal'].show()
          return

        } else if (res.data.includes("http://") || res.data.includes("https://")) {

          this.msg("ADESÃO", "CADASTRADO COM SUCESSO.", "success");
          this.form = '';
          localStorage.setItem('dadosEmpresa', JSON.stringify(this.dadosEmpresa))
          window.location.replace(res.data)
          return

        }

        this.form = '';
        localStorage.setItem('dadosEmpresa', JSON.stringify(this.dadosEmpresa))
        this.$router.push('/msg');

      }).catch((error) => {

        this.confirmandoEmail = false
        this.msg('ERRO', error.response.data, 'danger')

      })

    },

    reenviarEmail() {

      this.enviandoEmail = true

      api.put('adesao/reenvia-confirmacao-email', {

        idSolicitacao: this.idSolicitacao,
        email: this.form.email,
        emailConfirma: this.form.confEmail,
        nomeEmpresa: this.dadosEmpresa.nomeEmpresa,
        codUrl: this.dadosEmpresa.codUrl

      })
      .then(() => {

        this.codVerificacao = ["", "", "", "", "", ""]
        this.enviandoEmail = false
        this.naoRecebiCodigo = false

      }).catch((error) => {

        this.enviandoEmail = false
        this.msg('ERRO', error.response.data, 'danger')

      })

    },

    getDadosSolicitacaoParaConfirmarEmail(keyValidacao) {

      api.get(`adesao/solicitacao-confirmacao/${keyValidacao}`)
      .then((res) => {

        if (res.data.status != '24' && res.data.status != 25) this.$router.push("/adesao/erro");
        else {
      
          this.idSolicitacao = res.data.idSolicitacao
          this.msgValidacao = res.data.msgValidacao
          this.$refs['modal-verificacao-email'].show()

         /*  // ✅ Se o código já foi preenchido (automaticamente via URL)
          if (this.codVerificacao && this.codVerificacao.length === 6) {
            // Aguarda o modal ser renderizado antes de chamar a validação
            this.$nextTick(() => {
              this.validarCodigoVerificacao();
            });
          } */

              // ✅ Após o modal abrir, preencher os campos do código (se houver)
            this.$nextTick(() => {
              const cod = this.$route.query.cod;
              if (cod && cod.length === 6) {
                this.codVerificacao = cod.split('');
              }
            });

        }

      }).catch((error) => {

        this.msg('ERRO', error.response.data, 'danger')

      })

    },

    naoRecebiCodigoToggle() {

      this.form.email = ''
      this.form.confEmail = ''
      this.naoRecebiCodigo = true

    },

  consultarCpf() {
      const empresa = this.$route.query.emp; // pega o ?emp=...

      if (!empresa) {
        this.msg("ATENÇÃO", "Empresa não informada!", "warning");
        return;
      }

      // CPF vem do campo do modal
      const cpf = this.cpfTracking;

      if (cpf && cpf.length === 14) {
        api.get(`adesao/ConsultaTracking/${empresa}/${cpf}`)
          .then((response) => {
            if (response.data.status === "cpf_invalido") {
              this.msg("ATENÇÃO", `CPF ${response.data.cpf} inválido!`, "warning");

               this.$nextTick(() => {
                if (this.$refs.cpfInput) {
                  this.$refs.cpfInput.focus();
                }
              });
            }

            if (response.data.status === "empresa_invalida") {
              this.msg("ATENÇÃO", `Empresa ${response.data.empresa}  inexistente na base do Contratei`, "warning");

               this.$nextTick(() => {
                if (this.$refs.cpfInput) {
                  this.$refs.cpfInput.focus();
                }
              });
            }

            if (response.data.status === "cpf_existe_gestao") {
              this.msg(
                "ATENÇÃO",
                `Você já é cooperado, dúvidas entre em contato com a COOPERATIVA.`,
                "info"
              );

               this.$nextTick(() => {
                if (this.$refs.cpfInput) {
                  this.$refs.cpfInput.focus();
                }
              });
            }

            if (response.data.status === "cpf_nao_existe_contratei") {
              this.msg(
                "ATENÇÃO",
                `Digite seus dados para iniciar o processo de ADESÃO.`,
                "info"
              );

              // 👉 Preenche e bloqueia o CPF no formulário principal
              this.form.cpf = response.data.cpf;
              this.cpfBloqueado = true;
              this.$refs.trackingModal.hide();
            }

            if (response.data.status === "email_enviado") {
              this.msg(
                "ATENÇÃO",
                `Um e-mail foi enviado para ${response.data.email} com mais informações. Verifique sua caixa de entrada!`,
                "info"
              );

               this.$nextTick(() => {
                if (this.$refs.cpfInput) {
                  this.$refs.cpfInput.focus();
                }
              });
            }
          })
          .catch((error) => {
            const mensagem = error.response?.data || "Erro inesperado!";
            this.msg("ATENÇÃO", mensagem, "error");
          })
          .finally(() => {
            // limpa o campo do modal, mas não o formulário
            this.cpfTracking = "";
          });
      } else {
        this.msg("ATENÇÃO", "CPF incompleto!", "warning");
      }
    }



  },
  

  computed: {
    cssVars() {
      return {
        "--bg-color": this.bgColor,
        "--height": this.height + "px",
      };
    },
  },
};